import { ref, toValue, type MaybeRefOrGetter } from 'vue'
import { firmApi, officeApi } from '@/services/api'

/**
 * @deprecated use useInfinityOffice instead
 */
export const useInfiniteOffice = ({ values = ref([]), limit = ref(30), page = ref(0), firmId }: { values?: any; limit?: any; page?: any; firmId?: MaybeRefOrGetter<string | undefined> }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    const isArray = Array.isArray(values.value)
    if (isArray) {
      const officeIndex = values.value.findIndex(office => office._id === selected._id)
      if (officeIndex > -1)
        return values.value.splice(officeIndex, 1)
      values.value.push(selected)
    }
    else {
      values.value = selected
    }
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const scopedFirmId = toValue(firmId)
    const officeRequest = scopedFirmId
      ? await firmApi.adminFilterFirmOffices(scopedFirmId, { page: page.value, limit: limit.value, display: options.search }).promise
      : await officeApi.filter({ page: page.value, limit: limit.value, display: options.search }).promise
    loading.value = false
    haveMore.value = officeRequest.count.currentPage < officeRequest.count.totalPages
    list.value = options.new ? officeRequest.docs : [...list.value, ...officeRequest.docs]
    page.value++
  }

  const remove = (toRemove) => {
    const isArray = Array.isArray(values.value)
    if (isArray) {
      const foundIndex = values.value.findIndex(office => office._id === toRemove._id)
      if (foundIndex === -1)
        return

      values.value.splice(foundIndex, 1)
    }
    else {
      values.value = null
    }
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    values,
  }
}

export const useInfinityOffice = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), recruitmentScope = false, hrScope = false }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true
      const searchRequest = officeApi.filter({ page: page.value, limit: limit.value, display: search.value, recruitmentScope, hrScope })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage
      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
